import styled from "styled-components";
interface IProps {
  color?: React.CSSProperties["color"];
  background?: React.CSSProperties["background"];
}
export const Styles = styled.div<IProps>`
  .ant-select-selector {
    background: ${(props) =>
      props.background ? `${props.background} !important` : "#fff"};
    .ant-select-selection-item {
      color: ${(props) => (props.color ? props.color : "")};
    }
  }
`;
